import BaseService from './BaseService';

class OrderService extends BaseService {
  loadData(criteria) {
    return this.get('/api/feed/data', criteria);
  }
}

export default OrderService;



// WEBPACK FOOTER //
// ./src/services/OrderService.js